// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSidebar.tsx — PropelMapper web app sidebar / nav shell.
//
// The persistent left-hand navigation chrome shared by every web surface
// (Home, Locations, Dashboards, Settings, …). Built entirely from --pm-* tokens
// — the dark nav background is --pm-surface-inverse, labels --pm-on-inverse-muted,
// eyebrows --pm-on-inverse-subtle — so it themes with the rest of the system and
// carries no hardcoded greens.
//
// Icons follow the system rule: PropelMapper CUSTOM icons (window.PM_ICONS via
// assets/icons/icon-data.js) are preferred — each item's `icon` is a custom base
// name (e.g. "home", "map-pin"); the shell auto-picks the -outline glyph when
// inactive and -filled when active, tinted monochrome to the nav text color.
// For the handful of chrome glyphs with no custom equivalent (logout, groups,
// panel-collapse, list/table) it falls back to a Material Symbols ligature, so
// the consumer must also load the Material Symbols Outlined font.
//
// Variants: variant="full" (268px labelled) · variant="rail" (76px icon-only).

const PMSB_MARK =
  '<svg viewBox="0 0 102 156" width="29" height="44" fill="currentColor" aria-hidden="true">' +
  '<rect rx="18.6" x="0" y="0" width="101.78" height="37.21"></rect>' +
  '<rect rx="19.5" x="0" y="73" width="39" height="83"></rect>' +
  '<rect rx="18.6" x="45.96" y="71.13" width="55.81" height="37.21"></rect>' +
  '<rect rx="18.5" x="65" y="0" width="37" height="108"></rect></svg>';

const PMSB_CSS = `
.pmsb{box-sizing:border-box;flex:0 0 268px;width:268px;background:var(--pm-surface-inverse);color:var(--pm-on-inverse);display:flex;flex-direction:column;padding:18px 16px 16px;height:100%;overflow-y:auto;font-family:var(--pm-font-display,var(--pm-font-sans))}
.pmsb *{box-sizing:border-box}
.pmsb::-webkit-scrollbar{width:0}
.pmsb-logo{display:flex;align-items:center;gap:11px;padding:6px 8px 0;margin-bottom:20px}
.pmsb-mark{flex:0 0 auto;color:var(--pm-on-inverse);display:grid;place-items:center}
.pmsb-mark svg{display:block;width:29px;height:44px}
.pmsb-word{font-weight:700;font-size:11px;line-height:1.12;letter-spacing:.04em;color:var(--pm-on-inverse);white-space:pre-line}
.pmsb-collapse{margin-left:auto;width:32px;height:32px;display:grid;place-items:center;border:none;background:none;color:rgba(255,255,255,.55);cursor:pointer;border-radius:8px;font-family:inherit}
.pmsb-collapse:hover{background:rgba(255,255,255,.08);color:#fff}
.pmsb-item{display:flex;align-items:center;gap:13px;padding:11px 14px;border-radius:12px;color:var(--pm-on-inverse-muted);font-size:16px;font-weight:600;text-decoration:none;cursor:pointer;transition:.12s;border:none;background:none;font-family:inherit;width:100%;text-align:left}
.pmsb-item:hover{background:rgba(255,255,255,.07);color:#fff}
.pmsb-item.is-active{background:rgba(255,255,255,.13);color:#fff;font-weight:700}
.pmsb-ic{display:inline-flex;flex:0 0 auto;line-height:0}
.pmsb-ic svg{width:100%;height:100%;display:block}
.pmsb-ilabel{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.pmsb-eyebrow{font-size:12px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--pm-on-inverse-subtle);padding:0 14px;margin:24px 0 7px}
.pmsb-div{height:1px;background:rgba(255,255,255,.10);margin:16px 6px 4px}
.pmsb-new{margin-left:auto;font-size:11px;font-weight:700;letter-spacing:.05em;color:var(--green-300,#9BDA99);background:rgba(155,218,153,.16);border-radius:999px;padding:3px 11px}
.pmsb-ext{margin-left:auto;display:inline-flex;width:17px;height:17px;color:var(--pm-on-inverse-subtle)}
.pmsb-grow{flex:1;min-height:18px}
.pmsb-team{display:flex;align-items:center;gap:13px;background:rgba(255,255,255,.06);border-radius:14px;padding:12px 16px;margin:0 2px 12px}
.pmsb-team-av{width:46px;height:46px;border-radius:13px;background:linear-gradient(140deg,var(--green-500,#46A56A),var(--green-800,#1E453A));display:grid;place-items:center;color:#fff;font-weight:700;font-size:20px;flex:0 0 46px}
.pmsb-team-eyebrow{font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--pm-on-inverse-subtle)}
.pmsb-team-name{font-size:16px;font-weight:700;color:#fff;margin-top:3px}
.pmsb-bottom{display:flex;align-items:center;gap:18px;padding:0 8px 2px}
.pmsb-bell{position:relative;width:46px;height:46px;border-radius:50%;background:#fff;border:none;display:grid;place-items:center;cursor:pointer;color:var(--pm-accent);flex:0 0 46px}
.pmsb-badge{position:absolute;top:-1px;right:-1px;min-width:20px;height:20px;border-radius:999px;background:var(--pm-accent-critical);color:#fff;font-size:11px;font-weight:700;display:grid;place-items:center;padding:0 5px;border:2px solid var(--pm-surface-inverse)}
.pmsb-logout{display:flex;align-items:center;gap:12px;color:var(--pm-on-inverse-muted);font-size:16px;font-weight:600;cursor:pointer;text-decoration:none;background:none;border:none;font-family:inherit}
.pmsb-logout:hover{color:#fff}
.pmsb--rail{flex:0 0 76px;width:76px;align-items:center;padding:14px 0 12px;gap:3px}
.pmsb--rail .pmsb-word,.pmsb--rail .pmsb-team,.pmsb--rail .pmsb-new,.pmsb--rail .pmsb-ext,.pmsb--rail .pmsb-div,.pmsb--rail .pmsb-ilabel{display:none}
.pmsb--rail .pmsb-eyebrow{margin:7px auto;padding:0;width:22px;height:1px;overflow:hidden;background:rgba(255,255,255,.13);font-size:0;line-height:0;text-indent:-999px}
.pmsb--rail .pmsb-logo{justify-content:center;padding:0;margin-bottom:10px}
.pmsb--rail .pmsb-collapse{margin:0 0 6px}
.pmsb--rail .pmsb-item{flex-direction:column;width:52px;height:52px;padding:0;justify-content:center;border-radius:13px}
.pmsb--rail .pmsb-bottom{flex-direction:column;gap:14px;padding:0}
.pmsb--rail .pmsb-logout .pmsb-logout-tx{display:none}
.material-symbols-outlined{font-variation-settings:'FILL' 0,'wght' 400,'GRAD' 0,'opsz' 24}
`;

function pmsbEnsureCSS() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pmsb-css")) return;
  const s = document.createElement("style");
  s.id = "pmsb-css";
  s.textContent = PMSB_CSS;
  document.head.appendChild(s);
}

export function PMSidebar({
  variant = "full",
  brand = {},
  sections = [],
  topItems = [],
  activeId,
  team = null,
  notificationCount = 0,
  collapsible = true,
  onNavigate,
  onToggleCollapse,
  className = "",
  style = {},
  ...rest
}) {
  pmsbEnsureCSS();
  const rail = variant === "rail";
  const word = (brand && brand.wordmark) || "PROPEL\nMAPPER";

  // Custom-icon-first: pick -outline (inactive) / -filled (active) from
  // window.PM_ICONS; tint monochrome to the item's currentColor. Fall back to a
  // Material Symbols ligature for chrome glyphs the custom set doesn't cover.
  const ICON_VARS = {
    "--icon-fg": "currentColor",
    "--icon-accent": "currentColor",
    "--icon-accent-2": "currentColor",
    "--icon-accent-3": "currentColor",
  };
  const renderIcon = (base, active, size, extraClass = "") => {
    const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
    const outline = base + "-outline", filled = base + "-filled";
    let name = null;
    if (active) name = I[filled] ? filled : (I[outline] ? outline : (I[base] ? base : null));
    else name = I[outline] ? outline : (I[filled] ? filled : (I[base] ? base : null));
    if (name && I[name]) {
      return (
        <span
          className={"pmsb-ic " + extraClass}
          aria-hidden="true"
          style={{ width: size, height: size, ...ICON_VARS }}
          dangerouslySetInnerHTML={{ __html: I[name] }}
        />
      );
    }
    return (
      <span className={"material-symbols-outlined " + extraClass} aria-hidden="true"
        style={{ fontSize: size, lineHeight: 0 }}>{base}</span>
    );
  };

  const Item = (item) => (
    <button
      key={item.id}
      type="button"
      className={"pmsb-item" + (item.id === activeId ? " is-active" : "")}
      title={rail ? item.label : undefined}
      onClick={() => onNavigate && onNavigate(item)}
    >
      {renderIcon(item.icon, item.id === activeId, 22)}
      <span className="pmsb-ilabel">{item.label}</span>
      {item.badge && !rail ? <span className="pmsb-new">{item.badge}</span> : null}
      {item.external && !rail ? renderIcon("external-link", false, 17, "pmsb-ext") : null}
    </button>
  );

  return (
    <aside
      className={"pmsb" + (rail ? " pmsb--rail" : "") + (className ? " " + className : "")}
      style={style}
      {...rest}
    >
      <div className="pmsb-logo">
        <span className="pmsb-mark" dangerouslySetInnerHTML={{ __html: PMSB_MARK }} />
        <span className="pmsb-word">{word}</span>
        {collapsible ? (
          <button
            type="button"
            className="pmsb-collapse"
            title={rail ? "Expand" : "Collapse"}
            onClick={onToggleCollapse}
          >
            {renderIcon(rail ? "left_panel_open" : "left_panel_close", false, 22)}
          </button>
        ) : null}
      </div>

      {topItems.map(Item)}
      {topItems.length ? <div className="pmsb-div" /> : null}

      {sections.map((sec, si) => (
        <React.Fragment key={si}>
          <div className="pmsb-eyebrow">{sec.label}</div>
          {(sec.items || []).map(Item)}
        </React.Fragment>
      ))}

      <div className="pmsb-grow" />

      {team && !rail ? (
        <div className="pmsb-team">
          <div className="pmsb-team-av">{team.initial}</div>
          <div>
            <div className="pmsb-team-eyebrow">Team</div>
            <div className="pmsb-team-name">{team.name}</div>
          </div>
        </div>
      ) : null}

      <div className="pmsb-bottom">
        <button type="button" className="pmsb-bell" title="Notifications">
          {renderIcon("bell", false, 24)}
          {notificationCount > 0 ? (
            <span className="pmsb-badge">{notificationCount > 99 ? "99+" : notificationCount}</span>
          ) : null}
        </button>
        <button type="button" className="pmsb-logout" title="Log out">
          {renderIcon("logout", false, 23)}
          <span className="pmsb-logout-tx">Log out</span>
        </button>
      </div>
    </aside>
  );
}
